<template>
    <div v-if="groupedMeetings.length > 0">
        <aside class="table">
            <div v-for="(group, index) in groupedMeetings" :key="index" class="group"
                :class="{ visible: activeGroup === index }">
                <div v-for="(meeting, i) in group" :key="i" :class="{ row: true, placeholder: meeting.placeholder }">
                    <p class="hour">{{ meeting.time }}</p>
                    <p class="title">{{ meeting.action }}</p>
                    <p class="room">{{ meeting.room }}</p>
                </div>
            </div>
            
        </aside>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue"
import apiClient                                 from "@/api"

const meetings      = ref([])
const activeGroup   = ref(0)
let intervalId      = null
let fetchIntervalId = null

const fetchMeetings = async () => {
    try {
        const response = await apiClient.get("get_collective_meetings/")
        meetings.value = response.data.data
    } catch (error) {
        console.error("Error fetching meetings:", error)
    }
}

// Split meetings into groups of 3
const groupedMeetings = computed(() => {
    const groups = []
    for (let i = 0; i < meetings.value.length; i += 3) {
        const group = meetings.value.slice(i, i + 3)

        // Add placeholder rows if the group has less than 3 meetings
        while (group.length < 3) {
            group.push({ time: "-", action: "-", room: "-", placeholder: true })
        }

        groups.push(group)
    }
    return groups
})

onMounted(async () => {
    await fetchMeetings()

    intervalId = setInterval(() => {
        if (activeGroup.value + 1 < groupedMeetings.value.length) {
            activeGroup.value += 1
        } else {
            activeGroup.value = 0
        }
    }, 10 * 1000)

    // Refresh data every 10 minutes
    fetchIntervalId = setInterval(fetchMeetings, 10 * 60 * 1000)
});

onUnmounted(() => {
    if (intervalId)      clearInterval(intervalId)
    if (fetchIntervalId) clearInterval(fetchIntervalId)
})
</script>

<style lang="scss" scoped>
.table {
    position: relative;
    width: 100%;
    font-size: 1.2vw;
    background-color: $dark-blue;
    color: #fff;
    overflow: hidden;
    height: auto;

    .group {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        opacity: 0;
        transition: opacity 1s ease-in-out;

        .row {
            display: grid;
            grid-template-columns: 12% 1fr auto;
            align-items: center;
            column-gap: 2rem;
            padding: 0.5rem 0;
            border-bottom: 1px solid $ciel-blue;

            &.placeholder {
                color: transparent;
                border-bottom: 1px solid $ciel-blue;                
            }

            .title {
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            p {
                margin: 0;
                display: inline;
                padding-inline: 1rem;
            }
        }
    }

    .group.visible {
        opacity: 1;
        position: relative;
    }
}
</style>